import { useEffect, useRef } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

// ----------------------------------------------------------------------

export default function ScrollToTop() {
  const { pathname } = useLocation();

  const navigationType = useNavigationType();

  const previous = useRef(pathname);

  useEffect(() => {
    if (previous.current !== pathname && navigationType !== 'POP') {
      window.scrollTo(0, 0);
    }
    previous.current = pathname;
  }, [pathname, navigationType]);

  return null;
}
